import { render, staticRenderFns } from "./SessionAdd.vue?vue&type=template&id=0b7fe9db&"
import script from "./SessionAdd.vue?vue&type=script&lang=js&"
export * from "./SessionAdd.vue?vue&type=script&lang=js&"
import style0 from "./SessionAdd.vue?vue&type=style&index=0&id=0b7fe9db&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports